import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import FireBaseService from './services/firebase';
import { Plugins } from '@capacitor/core';
const { SplashScreen } = Plugins;
if(SplashScreen) SplashScreen.hide();

//polyfills
//import 'core-js';
//import 'core-js/es6/map';
//import 'core-js/es6/set';
//import 'raf/polyfill';


const startApp = () => {
    ReactDOM.render(<App  />, document.getElementById('root'));
}

const startCordovaInit = () => {
    console.log('Init cordova');
    FireBaseService.saveToken();
}

if (!window.cordova) {
    startApp() 
} else {
    document.addEventListener('deviceready', startApp, false)
    document.addEventListener('deviceready', startCordovaInit, false)
}


// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
